import React, { memo, useCallback, useMemo, useState } from "react";

import { HalfCard } from "@swiggy-private/dls-web-core/dist/components/HalfCard";
import { LottieAnimation } from "@swiggy-private/core-ui";
import { isEmpty } from "@swiggy-private/js-utils";

import { CALLOUTS_BANNER_LOTTIE_PROPS } from "@dineout-payment-success-ui/constants/CalloutsBanner";
import { getCalloutsBannerLottieUrl } from "@dineout-payment-success-ui/helpers/CalloutsBanner";
import { ICalloutsBannerItem, ICalloutsBannerProps } from "@dineout-payment-success-ui/interfaces";
import { SUCCESS_PAGE_TEST_IDS } from "@swiggy-private/payment-test-ids";

import CalloutsBannerHalfCard from "./CalloutsBannerHalfCard";
import CalloutsBannerContent from "./CalloutsBannerContent";
import { CalloutsBannerTitleLottieWrapper, CalloutsBannerWrapper } from "./styles";

const CalloutsBanner: React.FC<ICalloutsBannerProps> = ({ calloutsBanner }) => {
    const [selectedItem, setSelectedItem] = useState<ICalloutsBannerItem | null>(null);
    const [isHalfCardOpen, setIsHalfCardOpen] = useState(false);
    // TODO: Handle multiple items in the banner in future by using carousel but now we are implementing only one item
    // dls-carousel component is scrollable for one component so we are implementing in this way
    const bannerItem = calloutsBanner?.items?.[0];

    const titleLottieUrl = useMemo(
        () => getCalloutsBannerLottieUrl(calloutsBanner?.titleLottieId),
        [calloutsBanner?.titleLottieId],
    );

    const handleItemClick = useCallback((item: ICalloutsBannerItem) => {
        setSelectedItem(item);
        setIsHalfCardOpen(true);
    }, []);

    const handleCloseHalfCard = useCallback(() => {
        setIsHalfCardOpen(false);
        setSelectedItem(null);
    }, []);

    if (isEmpty(bannerItem) || isEmpty(titleLottieUrl)) {
        return null;
    }

    return (
        <CalloutsBannerWrapper data-testid={SUCCESS_PAGE_TEST_IDS.CALLOUTS_BANNER}>
            <CalloutsBannerTitleLottieWrapper>
                <LottieAnimation
                    {...CALLOUTS_BANNER_LOTTIE_PROPS}
                    fileName={titleLottieUrl}
                    visible
                    playLottie
                    preserveAspect="xMidYMid meet"
                />
            </CalloutsBannerTitleLottieWrapper>
            <CalloutsBannerContent item={bannerItem} onItemClick={handleItemClick} />
            <HalfCard
                isOpen={isHalfCardOpen}
                onClose={handleCloseHalfCard}
                closeOnOverlayClick
                hideCloseIcon
                hasCustomPadding
            >
                <CalloutsBannerHalfCard callouts={selectedItem?.callouts} onCtaClick={handleCloseHalfCard} />
            </HalfCard>
        </CalloutsBannerWrapper>
    );
};

export default memo(CalloutsBanner);
